import React from "react";
import { Box, MainText } from "app/components/common";

interface IProps {
  info: React.ReactElement;
  description: string;
}

const ProgressInfosBox = ({ info, description }: IProps) => {
  return (
    <Box
      backgroundColor="neutral.white"
      borderRadius={8}
      alignItems="center"
      justifyContent="center"
      paddingHorizontal="xs"
      paddingVertical="sm"
    >
      {info}
      <MainText
        color="neutral.600"
        variant="l3-medium"
        marginTop="xxs"
        numberOfLines={1}
      >
        {description}
      </MainText>
    </Box>
  );
};

export default ProgressInfosBox;
